export const PROGRESS_SECTION_STATE_KEY = "progress-section-state-v1";

export const DEFAULT_PROGRESS_SECTION_STATE = {
  overview: true,
  "training-volume": true,
  "period-comparison": false,
  "metric-history": false,
  "power-duration": true,
  "training-load": true,
  "aerobic-fitness": true,
};

export function loadProgressSectionState() {
  if (typeof window === "undefined" || !window.sessionStorage) {
    return { ...DEFAULT_PROGRESS_SECTION_STATE };
  }

  try {
    const raw = window.sessionStorage.getItem(PROGRESS_SECTION_STATE_KEY);
    if (!raw) {
      return { ...DEFAULT_PROGRESS_SECTION_STATE };
    }
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== "object") {
      return { ...DEFAULT_PROGRESS_SECTION_STATE };
    }
    return {
      ...DEFAULT_PROGRESS_SECTION_STATE,
      ...parsed,
    };
  } catch {
    return { ...DEFAULT_PROGRESS_SECTION_STATE };
  }
}

export function saveProgressSectionState(state) {
  if (typeof window === "undefined" || !window.sessionStorage) {
    return;
  }
  try {
    window.sessionStorage.setItem(PROGRESS_SECTION_STATE_KEY, JSON.stringify(state));
  } catch {
    // Ignore blocked or unavailable sessionStorage.
  }
}
